export default import.meta.ROLLDOWN_FILE_URL_hn3f3MXWg4mIpdmMggDGaA